export { FAQ } from './FAQ';
export type { Props as FAQProps } from './FAQ';
